import { levelMapScene } from "@kit/map";
import { track } from "@kit/telemetry";
import { meta } from "./meta";
import { AkisScene } from "./AkisScene";

const AkisMap = levelMapScene({
  id: "akis",
  gameScene: "akis",
  title: { tr: "Akış", en: "Flow" },
  accent: 0x2ec4b6,
  firstTheme: 5,
  track,
  describe: (_n, lang) => (lang === "tr" ? "Atıcı sırasını kur · resmi %40 açılmadan bil, 3 yıldız al" : "Plan the shooter queue · name the picture before 40% for 3 stars"),
});

/** Embeddable contract (docs/design/platform.md): the shell starts these scenes in its own Phaser game. */
export const game = { meta, scenes: [AkisMap, AkisScene] };
